import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetVotacoesData() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getVotacoesData = useCallback(
        () =>
            invocarApi({
                url: `/api/v1/votacao/data`,
                method: 'GET',
                enviarTokenUsuario: true,
                baseURL: VariaveisAmbiente.apiClickupLicUrl,
                timeout: 30000
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getVotacoesData,
    };
}
